<template>
    <div class="wrap">
        <!-- <div class="title">
            <h2>同步绑定</h2>
        </div> -->
        <div class="inner-box">
            <div>
                <el-button @click="allSubject" type="success" size="medium">主体汇总</el-button>
                <el-button @click="unbound" type="primary" size="medium" style="margin-left: 10px;">待绑定主体</el-button>
                <el-button @click="hasBound" type="primary" size="medium" style="margin-left: 10px;">已绑定主体</el-button>
                <el-button  @click="updateSync" type="warning" size="medium" style="margin-left: 500px">更新同步</el-button>
            </div>
            <div class="mt20">
                <el-input placeholder="名称、TOBID、TOGID、负责人、许可证" class="w350 seekIpt" v-model="searchInput" @keyup.enter.native="search">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                </el-input>
                <el-cascader class="ml20 w300" v-model="areaId" :options="areaList.options" @change="areaChange" :props="areaList.props" clearable placeholder="所属行政区" ref="cascader"></el-cascader>
                <el-select class="ml20 w200" v-model="buyerTypeValue" @change="buyerTypeChange" multiple collapse-tags placeholder="行业类型">
                    <el-option v-for="item in buyerTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-select class="ml20 w120" v-model="scTypeValue" @change="scTypeChange" clearable placeholder="公立/私立">
                    <el-option v-for="item in scTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-select class="ml20 w120" v-model="availableValue" @change="availableChange" clearable placeholder="启用状态">
                    <el-option v-for="item in availableTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-select class="ml20 w120" v-model="togBindStatusValue" @change="bindChange" clearable placeholder="绑定状态">
                    <el-option v-for="item in togBindStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
            <div style="margin-top: 10px;">
                <el-table :data="tableData" border style="width: calc(100% - 10px);" :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="tableLoading">
                    <el-table-column label="序号" width="80" type=index >
                        <template slot-scope="scope">
                            {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="guid" label="TOBID" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.guid ? scope.row.guid: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="buyerName" label="TOB主体名称" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.buyerName ? scope.row.buyerName: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="buyerType" label="行业类型" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.buyerType ? scope.row.buyerType: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="scType" label="公立私立" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.scType ? scope.row.scType: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="available" label="状态" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.available ? scope.row.available: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="areaName" label="所属行政区" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.areaName ? scope.row.areaName: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="legalPerson" label="负责人" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.legalPerson ? scope.row.legalPerson: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="tel" label="联系方式" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.tel ? scope.row.tel: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="address" label="地址" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.address ? scope.row.address: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="syncTime" label="同步时间" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.syncTime ? scope.row.syncTime: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="togBindStatus" label="绑定状态" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.togBindStatus ? scope.row.togBindStatus: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="togId" label="TOGID" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.togId ? scope.row.togId: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="togName" label="TOG主体名称" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.togName ? scope.row.togName: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="togLicense" label="许可证号" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.togLicense ? scope.row.togLicense: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="togBindTime" label="绑定时间" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.togBindTime ? scope.row.togBindTime: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" min-width="200">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.togBindStatus === '已绑定'" @click="toUnbind(scope.row)" type="warning" plain size="small">解绑</el-button>
                            <el-button v-if="scope.row.togBindStatus === '已绑定'" @click="togDetail(scope.row)" type="info" plain size="small">TOG档案</el-button>
                            <el-button v-if="scope.row.togBindStatus === '未绑定'" @click="toBind(scope.row)" type="primary" plain size="small">绑定</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px; margin-right:10px"></ybPagination>
            <tog-sub-dialog v-if="togSubDialogVisible" :togSubData="togSubData" :tog-sub-dialog-visible="togSubDialogVisible" @closeTogSubDialog="closeTogSubDialogVisible"></tog-sub-dialog>

        </div>
    </div>
</template>
<script>

import * as subManageApi from '@/api/subManage'
import ybPagination from '@/components/ybPagination'
import * as mapping from '@/utils/enumList'
import TogSubDialog from './TogSubDialog'
export default {
    name: 'subjectList',
    components: {
        ybPagination,
        TogSubDialog
    },
    data() {
        return {
            searchInput: '',
            parentId: '0',
            areaId: '',
            areaList: {
                selectedOptions: [],
                options: [],
                parentCode: '',
                props: {
                    checkStrictly: true,
                    expandTrigger: 'hover',
                    value: 'areaId',
                    label: 'areaName',
                    children: 'children',
                    lazy: true,
                    lazyLoad(node, resolve) {}
                }
            },
            buyerTypes: mapping.getKeyVal('buyerType'),
            scTypes: mapping.getKeyVal('scType'),
            availableTypes: mapping.getKeyVal('available'),
            togBindStatus: mapping.getKeyVal('togBindStatus'),
            buyerTypeValue: [],
            scTypeValue: '',
            availableValue: '',
            togBindStatusValue: '',
            tableLoading: false,
            tableData: [],
            page: {
                pageSize: 10,
                pageNum: 1,
                total: 10
            },
            togSubData: {
                areaCode: '',
                entityId: ''
            },
            togSubDialogVisible: false
        }
    },
    computed: {
        params: function() { 
            let buyerTemp
            if (this.buyerTypeValue.length === 0) {
                this.buyerTypeValue = ''
            } else {
                buyerTemp = this.buyerTypeValue.join(',')
            }
            return {
                areaId: this.areaList.selectedOptions[this.areaList.selectedOptions.length - 1],
                buyerTypeStr: buyerTemp,
                current: this.page.pageNum,
                keyword: this.searchInput,
                scType: this.scTypeValue,
                size: this.page.pageSize,
                available: this.availableValue,
                togBindStatus: this.togBindStatusValue
            }
        }
    },
    methods: {
        // '主体汇总'按钮
        allSubject() {
            this.searchInput = ''
            this.areaId = ''
            this.areaList.selectedOptions = ''
            this.buyerTypeValue = ''
            this.scTypeValue = ''
            this.availableValue= ''
            this.togBindStatusValue = ''
            this.page.pageNum = 1
            this.tableRefresh()
        },
        // '待绑定主体'按钮
        unbound() {
            this.togBindStatusValue = '0'
            this.page.pageNum = 1
            this.tableRefresh()
        },
        // '已绑定主体'按钮
        hasBound() {
            this.togBindStatusValue = '1'
            this.page.pageNum = 1
            this.tableRefresh()
        },
        // '更新同步'按钮
        updateSync() {
            subManageApi.incrSync().then(res=>{
                if(res.code === 200) {
                    this.$message.success('同步成功')
                }
            }).catch(err=>{})
        },
        // 搜索
        search() {
            this.page.pageNum = 1
            this.tableRefresh()
        },
        // 点击区域节点前的圆圈进行选择
        areaChange(val) {
            this.page.pageNum = 1
            this.areaList.selectedOptions = val;
            this.tableRefresh();
        },
        // 学校类型筛选
        buyerTypeChange(value) {
            this.page.pageNum = 1
            this.tableRefresh()
        },
        // 公立私立筛选
        scTypeChange(value) {
            this.page.pageNum = 1
            this.tableRefresh()
        },
        // 启用状态筛选
        availableChange(value) {
            this.page.pageNum = 1
            this.tableRefresh()
        },
        // 绑定状态筛选
        bindChange(value) {
            this.page.pageNum = 1
            this.tableRefresh()
        },
        tableRefresh() {
            this.tableLoading = true
            subManageApi.subjectBindList(this.params).then(r => {
                if(r.code === 200) {
                    let data = r.data.records
                    data.forEach(el => {
                        el.scType = mapping.keyToVal('scType', el.scType)
                        el.buyerType = mapping.keyToVal('buyerType', el.buyerType)
                        el.available = mapping.keyToVal('available', el.available)
                        el.togBindStatus = mapping.keyToVal('togBindStatus', el.togBindStatus)
                    })
                    this.tableData = data
                    this.page.total = parseInt(r.data.total)
                }
                this.tableLoading = false;
            }).catch(err => {})
        },
        // 绑定
        toBind(row) {
            this.togSubData.areaCode = row.accessAreaCode;
            this.togSubData.entityId = row.guid;
            this.togSubDialogVisible = true;
        },
        // 解绑
        toUnbind(row) {
            this.$confirm('是否确认解除绑定？解除绑定将清空该学校的投诉反馈记录！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                subManageApi.togSubUnbind({entityId: row.guid}).then(r => {
                    if(r.code === 200) {
                        this.$message.success('解绑成功')
                        this.tableRefresh()
                    }
                }).catch(err => {})
            }).catch(e => {});
        },
        // 打开tog档案
        togDetail(row) {
            let url = row.togUrl + "/xcws/subject/restaurant/detail" + '?id=' + row.togId + '&xcwsIsShow=1'
            window.open(url)
        },
        // 关闭tog弹窗
        closeTogSubDialogVisible() {
            this.togSubDialogVisible = false;
        },
        // 页数改变
        pageCurrentChange(num) {
            if(num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.tableRefresh();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            if(size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.tableRefresh();
            }
        }
    },
    created() {
        let that = this;
        that.areaList.props.lazyLoad = function (node, resolve) {
            let code = node.value ? node.value : that.parentId;
            if (code.length > 6) { 
                return resolve([]) 
            }
            subManageApi.getAreaList({parentId: code}).then(r => {
                if (r.code === 200) {
                    resolve(r.data)
                }
            });
        }
        this.tableRefresh();
    }
}
</script>
<style lang="scss" scoped>
    .wrap {
        width: 100%;
        height: calc(100% - 40px);
        text-align: left;
    }
</style>
